
import wx from 'weixin-js-sdk';
import request from '../../utils/http';
import common from '../../utils/common';
import global from '../../utils/global'
import { Toast } from 'vant';
const state = {
  noReadMsgList: {},  // 各个类型的未读通知
  appVersion: {
    newVersion: '',
    oldVersion: ''
  },  // app的版本号
  lang: 'zh', //语言
	keepAlive: ["learningIndex"],
  hasIMTips: 0, //  im消息提醒
}

const getters = {
  noReadMsgList: state => state.noReadMsgList,
  appVersion: state => state.appVersion,
	keepAlive: state => state.keepAlive
}

const mutations = {
	SETKEEPALIVE: (state, keepAlive) => {
		state.keepAlive = global.unique(keepAlive);
	},
  SETNOREADMSGLIST(state, noReadMsgList) {
    state.noReadMsgList = noReadMsgList
  },
  SETAPPVERSION(state, appVersion) {
    // state.appVersion = appVersion
    state.appVersion = JSON.parse(appVersion)
  },
  CHANGELANG(state, lang) {
    // 0中文 1英文 2繁体
    let now_lang = lang=="en" ? 1:(lang=="tw" ? 2:0);
    localStorage.setItem("now_lang", now_lang);
    state.lang = lang;
    localStorage.setItem("lang", lang)
  },
  SETIMTIPSSTATUS(state, hasIMTips) {
    state.hasIMTips = hasIMTips;
  }
}

const actions = {
	setkeepalive({commit}, value) {
	  commit('SETKEEPALIVE', value)
	},
  setNoReadMsgList({commit}, value) {
    commit('SETNOREADMSGLIST', value)
  },
  setAppVersion({
    commit
  }, value) {
    commit('SETAPPVERSION', value)
  },
  wxShare({
		commit
	}, params) {
		let desc = (params.desc || "").replace(/<[^>]+>/g,""), // 分享的简介
			title = params.title || "", // 分享的标题
			shareUrl = params.link || window.location.href,   // 分享的链接
			imgUrl = params.imgUrl    // 分享的缩略图
      // shareUserId = params.shareUserId||"", // 分享的用户ID,用于分享成功后回调
      // contentType = params.contentType, // 0微信 1朋友圈
      // shareType = params.shareType||"", // 1转发浏览数 2转发数  3新增粉丝数
      // rankId = params.rankId||"",  //竞赛ID
      // rankType = params.rankType||""  // 0竞赛 1排名
      
      let link = window.location.href; // 请求JSSDK的页面路径
      // link = link.split('#')[0]; //签名需要传当前页面的url
      request.post(`${common.baseUrl}/competition/wxShare`, {
        url: link
      }).then(response => {
        if(!(response && response.success)) {
          return false;
        }
        let dataModel = response.dataModel
        // 请求成功后保存
        let appId = dataModel.appId;
        let timeStamp = dataModel.timeStamp;
        let nonceStr = dataModel.nonceStr;
        let signature = dataModel.signature;
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。  
          appId: appId,
          timestamp: timeStamp,
          nonceStr: nonceStr,
          signature: signature,
          jsApiList: [
            'checkJsApi',
            'hideAllNonBaseMenuItem',
            'showMenuItems',
            'onMenuShareTimeline', //分享到朋友圈
            'onMenuShareAppMessage', //分享给朋友
          ]
        });
        
     
        let share_config = {
          title: title, //分享卡片标题
          desc: desc, //摘要,如果分享到朋友圈的话，不显示摘要。
          link: shareUrl, //分享链接
          imgUrl: imgUrl, //分享图，默认当相对路径处理，所以使用绝对路径的的话，“http://”协议前缀必须在。
          success: function() {
            // if(shareType == 2) {
            //   if(rankId && shareUserId) {
            //     // 2转发数 回调 
            //     let params = new URLSearchParams();
            //     params.append('type', rankType);
            //     params.append('url', shareUrl);
            //     request.putForm(`${common.baseUrl}/competition/${rankId}/sharer/${shareUserId}/shareNum`, params).then({});
            //   }
            // }
            let instance = Toast('分享成功');
            setTimeout(() => {
              instance.close();
            }, 1000);
            return true;
          },
          'cancel': function() {
            // 用户取消分享后执行的回调函数
            let instance = Toast('您已取消分享');
            setTimeout(() => {
              instance.close();
            }, 1000);
            return false;
          }
        }
        wx.ready(function() {
          wx.hideAllNonBaseMenuItem();
          wx.showMenuItems({
            menuList: ["menuItem:share:appMessage", "menuItem:share:timeline", "menuItem:copyUrl"] // 要显示的菜单项，所有menu项见附录3
          });
          wx.onMenuShareAppMessage(share_config);
          wx.onMenuShareTimeline(share_config);
        })
        // wx.error(function(res){
        //     // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
        //   alert.log(res.errMsg);
        // });
      });
  },
  changeLang({
    commit
  }, value) {
    commit('CHANGELANG', value)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



//////////////////
// WEBPACK FOOTER
// ./store/modules/common.js
// module id = null
// module chunks = 